import { FC, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { Loader } from '@livechat/design-system-react-components';

import { StandardError } from 'types/error';
import { UnexpectedError } from 'components/error-message/UnexpectedError';
import { fetchTokenDetails } from 'hooks/use-get-token-details';
import Location from 'services/Location';
import { accountsClient } from 'services/connectivity/accounts/client';
import { saveItem } from 'helpers/storage/local-storage';

import * as styles from './styles';

declare const window: any;

export const Verification: FC = () => {
  const [error, setError] = useState<StandardError | null>(null);

  useEffect(() => {
    (async () => {
      const accessToken = Location.getUrlParam('access_token');
      const request = Location.getUrlParam('request');
      const clientID = Location.getUrlParam('client_id');
      const redirectURL = Location.getUrlParam('redirect_uri');
      const responseType = Location.getUrlParam('response_type');

      try {
        await fetchTokenDetails(accessToken);
      } catch (e) {
        // Redirect to signin page when verification code is expired
        window.location.href = '/';
        return;
      }

      Cookies.set('access_token', accessToken, { secure: true, sameSite: 'none' });
      const { error: verifyError } = await accountsClient.verifyAccount(
        Location.getUrlParam('jwt_token')
      );

      if (verifyError) {
        setError({
          responseCode: verifyError.status,
          requestId: verifyError.request_id,
          description: verifyError.error_description,
        });
        return;
      }

      // if everything is ok, redirect to the original url with jar params
      // the token carries session transfer, we can enstablish a new session if needed
      if (accessToken) {
        saveItem('signup', '1');
        const params = new URLSearchParams();
        params.set('access_token', accessToken);
        if (request) {
          params.set('request', request);
        }
        if (clientID && redirectURL && responseType) {
          params.set('client_id', clientID);
          params.set('redirect_uri', redirectURL);
          params.set('response_type', responseType);
        }
        params.set('signup', '1');
        window.location.href = `/?${params.toString()}`;
        return;
      }

      window.location.href = '/';
    })();
  }, []);

  if (error) {
    return (
      <UnexpectedError requestId={error.requestId ?? ''} description={error.description ?? ''} />
    );
  }

  return <Loader size="large" css={styles.loaderContainer} />;
};
